import { React, Radio } from 'mondrian-react';

function RadiosSearch({ index, selectIndex, className }) {
  return (
    <>
      <div onChange={selectIndex} className={className}>
        <label>
          <Radio
            name="radiosSearch"
            id="tabela"
            value="tabelas"
            checked={index === 'tabelas'}
          >
            {' '}
            Tabela
          </Radio>
        </label>
        <label>
          <Radio
            name="radiosSearch"
            id="api"
            value="apis"
            checked={index === 'apis'}
          >
            {' '}
            API
          </Radio>
        </label>
      </div>
    </>
  );
}

export default RadiosSearch;
